import { render } from "./TimetableCard.vue?vue&type=template&id=0226ef54"
import script from "./TimetableCard.vue?vue&type=script&lang=js"
export * from "./TimetableCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__